"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const lodash_1 = require("lodash");
const component_flag_1 = require("@patternplate/component-flag");
const S = require("./info-pane.styles");
const info_pane_utils_1 = require("./info-pane.utils");
const search_trigger_1 = require("./search-trigger");
const info_pane_version_1 = require("./info-pane-version");
const info_pane_toggle_1 = require("./info-pane-toggle");
exports.InfoPane = function InfoPane(props) {
    const { className } = props;
    const innerProps = lodash_1.omit(props, ["className"]);
    return (React.createElement(S.StyledInfoPane, { className: className, hermit: props.hermit },
        React.createElement(exports.InnerInfoPane, Object.assign({}, innerProps))));
};
exports.InnerInfoPane = function InnerInfoPane(props) {
    return (React.createElement(S.StyledInnerPane, { className: props.className },
        React.createElement(S.StyledName, null,
            React.createElement(S.StyledDisplayName, null, props.name),
            React.createElement(S.StyledId, null, props.id)),
        props.children && React.createElement(S.StyledToolbar, null, props.children),
        React.createElement(S.StyledData, null,
            React.createElement("tbody", null,
                React.createElement("tr", null,
                    React.createElement(S.StyledDataCell, null,
                        React.createElement(S.StyledKey, null, "Version")),
                    React.createElement(S.StyledDataCell, null,
                        React.createElement(info_pane_version_1.InfoPaneVersion, { search: props.version }, props.version))),
                React.createElement("tr", null,
                    React.createElement(S.StyledDataCell, null,
                        React.createElement(S.StyledKey, null, "Flag")),
                    React.createElement(S.StyledDataCell, null,
                        React.createElement(search_trigger_1.SearchTrigger, { field: "flag", search: props.flag },
                            React.createElement(component_flag_1.Flag, null, props.flag)))),
                info_pane_utils_1.has(props.tags) && (React.createElement("tr", null,
                    React.createElement(S.StyledDataCell, null,
                        React.createElement(S.StyledKey, null, "Tags")),
                    React.createElement(S.StyledDataCell, null, props.tags.map(t => React.createElement(S.StyledTag, { key: t }, t))))))),
        React.createElement(info_pane_toggle_1.InfoPaneToggle, { head: "Manifest", enabled: props.manifestEnabled, name: "manifest" },
            React.createElement(S.StyledCode, { block: true, language: "json" }, props.manifest))));
};
//# sourceMappingURL=info-pane.js.map